/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AgentUpgradeBanner_agent$ref: FragmentReference;
export type AgentUpgradeBanner_agent = {|
  +version: ?string,
  +$refType: AgentUpgradeBanner_agent$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "AgentUpgradeBanner_agent",
  "type": "Agent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'adbf2dd8ed81adc48896bc4e1d3e23ad';
module.exports = node;
